<template>
  <Modal
    cancel-variant="primary"
    confirm-variant="primary-ghost"
    data-testid="high-frequency-play-slip-navbar-incomplete-plays-modal"
    :tracking="{
      action: 'checkout',
      topicKey: 'incomplete-plays-confirmation',
    }"
    @cancel="emit('cancel')"
    @confirm="emit('confirm')"
  >
    <template #headline>
      {{ $t('lottery.playslipnavbar.modal.incompleteplays.headline', 1) }}
    </template>

    <template #cancel>
      {{ $t('lottery.playslipnavbar.modal.incompleteplays.cancel') }}
    </template>

    <template #confirm>
      {{ $t('lottery.playslipnavbar.modal.incompleteplays.confirm') }}
    </template>

    {{ $t('lottery.playslipnavbar.modal.incompleteplays.message') }}
  </Modal>
</template>

<script lang="ts" setup>
const emit = defineEmits<{ (e: 'cancel' | 'confirm'): void }>()
</script>
